import { type ReactNode, useEffect } from 'react'

function Printed({ title, children }: { title: string; children: ReactNode }) {
  useEffect(() => {
    document.title = title
    window.print()
    return () => {
      document.title = 'Vet VPMS'
    }
  }, [title])

  return (
    <div style={{ fontFamily: 'Georgia, serif', color: '#111', maxWidth: '720px', margin: '0 auto', padding: '40px 32px', fontSize: '14px', lineHeight: '1.5' }}>
      {children}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '48px', marginTop: '56px' }}>
        <div style={{ borderTop: '1px solid #111', paddingTop: '4px', fontSize: '12px', color: '#444' }}>Signature</div>
        <div style={{ borderTop: '1px solid #111', paddingTop: '4px', fontSize: '12px', color: '#444' }}>Date</div>
      </div>
      <div className="no-print" style={{ marginTop: '48px', textAlign: 'center', color: '#999', fontSize: '12px' }}>
        Use your browser's print dialog (Ctrl+P / ⌘P) to save as PDF.
      </div>
    </div>
  )
}

/** Print-only page: shows loading/error states, then renders children and opens the print dialog. */
export function PrintShell({ title, loading, error, children }: {
  title: string
  loading: boolean
  error: string | null
  children: () => ReactNode
}) {
  const center = { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'sans-serif' }
  if (loading) return <div style={{ ...center, color: '#666' }}>Preparing document…</div>
  if (error) return <div style={{ ...center, color: '#b00020' }}>{error}</div>
  return <Printed title={title}>{children()}</Printed>
}
